"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateClaimLink = void 0;
var SEARCH_PARAMS = '?active_step=tour';
var generateClaimLink = exports.generateClaimLink = function generateClaimLink(clientID, claimID) {
  return "/tf/client/".concat(clientID, "/claim/").concat(claimID).concat(SEARCH_PARAMS);
};